import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as myGlobals from '../globals';

import { ConfigService } from '../config.service';

@Injectable()
export class DispatcherService {
  private _languages = myGlobals.apiurl + 'utility/languages';
  private _zoneUrl = myGlobals.apiurl + 'dispatcher/vehicleType/';
  private _addinfoUrl = myGlobals.apiurl + 'dispatcher/bookingHistory';
  private _images = myGlobals.apiurl + 'utility/uploadImage';
  private _logout = myGlobals.apiurl + 'dispatcher/logout';
  private _cancelservice = '';
  private _fileUpload = '';
  private _allzones = '';
  private _appconfig = myGlobals.apiurl + 'dispatcher/appConfig';
  private _profile = '';
  private _getdrivers = '';
  private _getallcards = '';
  private _goodstypes = '';
  private _dispatcherLivepath = '';
  private _pending_reff = '';
  private _submitreasons = '';
  private _getdetUrl = '';
  private _surgePrice = myGlobals.apiurl + 'dispatcher/fareEstimate';
  private _priceAll = myGlobals.apiurl + 'dispatcher/fareEstimateAll';
  private _goodsTypes = myGlobals.apiurl + 'dispatcher/goodsType/';
  private _postBooking = myGlobals.apiurl + 'dispatcher/bookRide';
  private _singleBooking = myGlobals.apiurl + 'dispatcher/book';

  // wallet services for dispatcher
  private _getcards = myGlobals.apiurl + 'dispatcher/customer/card';
  private _addcards = myGlobals.apiurl + 'dispatcher/card';
  private _deletecards = myGlobals.apiurl + 'dispatcher/card';
  private _wallet_details = myGlobals.apiurl + 'dispatcher/walletDetail';
  private _wallet_transactions =
    myGlobals.apiurl + 'dispatcher/walletTransaction';
  private _paymentSettings = myGlobals.apiurl + 'dispatcher/paymentSetting';
  private _rechargeWallet = myGlobals.apiurl + 'dispatcher/rechargeWallet';
  private _customerSearch = myGlobals.apiurl + 'dispatcher/customer/';
  private _CustomerCardDetails = myGlobals.apiurl + 'dispatcher/customer/card/';
  private _postNewCustomer = myGlobals.apiurl + 'dispatcher/customer';

  private _getCity = myGlobals.apiurl + 'dispatcher/city';

  constructor(private _http: HttpClient, private _conf: ConfigService) { }

  // get city
  getCity(user: any) {
    const body = JSON.stringify(user);
    return this._http.get(this._getCity, { headers: this._conf.header });
  }

  // api call for register new customer
  postNewCustomer(user: any) {
    const body = JSON.stringify(user);
    return this._http.post(this._postNewCustomer, body, {
      headers: this._conf.header
    });
  }
  // customer search
  customersearching(user: any) {
    const body = JSON.stringify(user);
    return this._http.get(this._customerSearch + user.email, {
      headers: this._conf.header
    });
  }
  // customer card details
  CustomerCardDetails(user: any) {
    const body = JSON.stringify(user);
    return this._http.get(this._CustomerCardDetails + user.id, {
      headers: this._conf.header
    });
  }

  // ZONE VALIDATION FOR ADD NEW FORM
  zone(data: any) {
    console.log('zone data', data);
    const body = JSON.stringify(data);
    return this._http.get(
      this._zoneUrl +
      1 +
      '/' +
      data.latitude +
      '/' +
      data.longitude +
      '/' +
      data.customerId,
      { headers: this._conf.header }
    );
  }

  // ZONE VALIDATION FOR ADD NEW FORM
  fareEstimate(data: any) {
    console.log(data);
    const body = JSON.stringify(data);
    return this._http.post(this._surgePrice, body, {
      headers: this._conf.header
    });
  }
  // Get All Vehicles price data
  fareEstimateAll(data: any) {
    const body = JSON.stringify(data);
    return this._http.post(this._priceAll, body, {
      headers: this._conf.header
    });
  }
  // ZONE VALIDATION FOR ADD NEW FORM
  getGoodstypes(data: any) {
    const body = JSON.stringify(data);
    return this._http.get(this._goodsTypes + data.vehicleTypeId, {
      headers: this._conf.header
    });
  }

  // Post BOOKING
  postBooking(data: any) {
    const body = JSON.stringify(data);
    const headers = new Headers();
    return this._http.post(this._postBooking, body, {
      headers: this._conf.header
    });
  }

  uploadImages(fileToUpload) {
    console.log('intype', fileToUpload);
    const headers = new Headers();
    const formData = new FormData();
    formData.append('image', fileToUpload);
    return this._http.post(this._images, formData, {
      headers: this._conf.header
    });
  }

  // ADD NEW BOOKING API----------------------------------------------------

  addinfo(user: any) {
    const body = JSON.stringify(user);
    const headers = new Headers();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    headers.append('Content-Type', 'application/json');
    return this._http.post(this._addinfoUrl, body, {
      headers: this._conf.header
    });
  }

  // GET USER DATA API----------------------------------------------------
  getdet(user: any) {
    const body = JSON.stringify(user);
    const headers = new Headers();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    headers.append('Content-Type', 'application/json');
    return this._http.post(this._getdetUrl, body, {
      headers: this._conf.header
    });
  }

  // CANCEL BOOKING BY PASSING BOOKING ID  ----------------------------------------------------
  cancelservice(user: any) {
    const body = JSON.stringify(user);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.post(this._cancelservice, body, {
      headers: this._conf.header
    });
  }

  // LOGOUT SERVICE

  loggedout(user: any) {
    const body = JSON.stringify(user);
    const headers = new Headers();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.post(this._logout, body, { headers: this._conf.setAuth() });
  }
  // GET PROFILE

  profile(user: any) {
    const body = JSON.stringify(user);
    const headers = new Headers();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.get(this._profile, { headers: this._conf.header });
  }

  // GET PENDING REFERRALS

  pendingRef(user: any) {
    const body = JSON.stringify(user);
    const headers = new Headers();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.get(this._pending_reff, { headers: this._conf.header });
  }
  // update PROFILE

  updateprofile(user: any) {
    const body = JSON.stringify(user);
    const headers = new Headers();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.put(this._profile, body, { headers: this._conf.header });
  }

  // GETTING ALL ZONES FOR PREPARING BULK UPLOAD IT CONVERTS TO TXT FORMAT AND DOWNLOAD

  allzones(user: any) {
    const body = JSON.stringify(user);
    const headers = new Headers();
    return this._http.get(this._allzones, { headers: this._conf.header });
  }

  appconfig(user: any) {
    // const body = JSON.stringify(user);
    // const headers = new Headers();
    // headers.append('authorization', sessionStorage.getItem('authtoken'));
    // console.log('app config token-------->', this._conf.header);
    return this._http.get(this._appconfig + '/' + 3, {
      headers: this._conf.header
    });
  }

  // GETTING ALL THE DRIVERS LIST
  getdrivers(user: any) {
    const body = JSON.stringify(user);
    const headers = new Headers();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.get(
      this._getdrivers +
      '/' +
      user.lt +
      '/' +
      user.lg +
      '/' +
      sessionStorage.getItem('chn') +
      '/' +
      sessionStorage.getItem('presence'),
      { headers: this._conf.header }
    );
  }

  // GET ALL THE SLAVE TYPES
  goodstypes(user: any) {
    const body = JSON.stringify(user);
    const headers = new Headers();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.get(this._goodstypes, { headers: this._conf.header });
  }

  // GET review reasons based on rating
  submitereivew(user: any) {
    const body = JSON.stringify(user);
    const headers = new Headers();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.post(this._submitreasons, body, {
      headers: this._conf.header
    });
  }

  // dispatcher services for wallet

  // GETTING ALL THE CARDS ADDED
  getcards(user) {
    // const body = JSON.stringify(user);
    return this._http.get(`${this._getcards}/${user}`, {
      headers: this._conf.header
    });
  }

  // add cards
  addcards(user: any) {
    const body = JSON.stringify(user);
    return this._http.post(this._addcards, body, {
      headers: this._conf.header
    });
  }

  // delete cards
  deletecard(user: any) {
    const body = JSON.stringify(user);
    return this._http.delete(this._deletecards, { headers: this._conf.header });
  }

  // get wallet details
  wallet(user: any) {
    const body = JSON.stringify(user);
    return this._http.get(this._wallet_details, { headers: this._conf.header });
  }

  // recharge wallet from wallet component
  recharge(user: any) {
    const body = JSON.stringify(user);
    return this._http.post(this._rechargeWallet, body, {
      headers: this._conf.header
    });
  }

  // GET wallet transactions for wallet page
  wallettrans(user: any) {
    const body = JSON.stringify(user);
    return this._http.get(this._wallet_transactions + '/' + user.pageIndex, {
      headers: this._conf.header
    });
  }

  // GET PROFILE\
  payment(user: any) {
    const body = JSON.stringify(user);
    return this._http.get(this._paymentSettings, {
      headers: this._conf.header
    });
  }

  getLanguages() {
    return this._http.get(this._languages);
  }
}
